import { ISession } from '@/core/session/types'

export const adParams = [
  'ad_campaign_id',
  'ad_set_id',
  'ad_id',
  'ad_placement',
  'ad_source',
  'email_campaign',
  'ltp_email_campaign',
] as const

export type TAdParam = (typeof adParams)[number]

export const adParamsToUtmParams: Record<TAdParam, string> = {
  ad_campaign_id: 'utm_campaign',
  ad_set_id: 'utm_medium',
  ad_id: 'utm_content',
  ad_placement: 'utm_term',
  ad_source: 'utm_source',
  email_campaign: 'utm_email_campaign',
  ltp_email_campaign: 'utm_ltp_email_campaign',
} as const

export type TAdData = { [key in TAdParam]?: string }

export const extractAdParams = function (sessionContext: ISession): TAdData {
  const result: TAdData = {}
  if (Object.keys(sessionContext.utmParams)) {
    for (const key in adParamsToUtmParams) {
      const utmParamName = adParamsToUtmParams[key as TAdParam]
      const value = sessionContext.utmParams[utmParamName]
      if (value) {
        result[key as TAdParam] = value
      }
    }
  }

  return result
}
